import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import ReadQuran from './pages/home';
// import Home from './pages/home';
// import BacaQuran from './pages/baca_quran';
import Layouts from './pages/layouts';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Layouts />
  </React.StrictMode>
);


// reportWebVitals();
